module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_redefine.js
// module id = 324
// module chunks = 0